import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useMemo, forwardRef, useEffect } from 'react';
import classes from './drawer.module.css';
import BuyLocalContent from './buyLocalContent';
import BuyOnlineContent from './buyOnlineContent';
import SelectedOptionsContent from './selectedOptionsContent';
import DrawerHeader from './drawerHeader';
import BuyOptionsContent from './BuyOptionsContent';
import DownloadsPopup from '../downloadsPopup';
import Button from '@magento/venia-ui/lib/components/Button';
import { useHistory, Link } from 'react-router-dom';
import { useUserContext } from '@magento/peregrine/lib/context/user';
import { addScrollToBody, removeScrollFromBody } from '../../../../../hooks/utils';
import { getCustomerGroup } from '../../../../../Utils/utils';
var Drawer = forwardRef(function (_ref, ref) {
  var _customAttributes$fin, _customAttributes$fin2, _customAttributes$fin3, _customAttributes$fin4, _drawerTitle$type;

  var type = _ref.type,
      option = _ref.option,
      close = _ref.close,
      onSelectionChange = _ref.onSelectionChange,
      customAttributes = _ref.customAttributes,
      product = _ref.product;
  useEffect(function () {
    if (type) removeScrollFromBody(false);else addScrollToBody(false);
    return function () {
      return addScrollToBody(false);
    };
  }, [type]);

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      isUserSignedIn = _useUserContext2[0].isSignedIn;

  var _getCustomerGroup = getCustomerGroup(),
      isTradeDirectAccount = _getCustomerGroup.isTradeDirectAccount,
      isConsumer = _getCustomerGroup.isConsumer,
      isHfEmployee = _getCustomerGroup.isHfEmployee;

  var history = useHistory();
  var drawerTitle = useMemo(function () {
    var _ref2;

    return _ref2 = {
      BUY_LOCAL: {
        title: 'Buy Local'
      },
      BUY_ONLINE: {
        title: 'Buy Online'
      },
      BUY_OPTIONS: {
        title: 'Buy Options'
      },
      SELECT_OPTIONS: {
        title: 'Select Finish'
      }
    }, _defineProperty(_ref2, "BUY_OPTIONS", {
      title: 'Buy Options'
    }), _defineProperty(_ref2, "CUSTOM", {
      title: 'Custom'
    }), _defineProperty(_ref2, "DOWNLOADS", {
      title: 'Downloads'
    }), _ref2;
  }, []);
  var drawerContent;

  switch (type) {
    case 'BUY_OPTIONS':
      drawerContent = React.createElement(BuyOptionsContent, {
        customAttributes: customAttributes
      });
      break;

    case 'BUY_LOCAL':
      drawerContent = React.createElement(BuyLocalContent, {
        classes: {
          directionsContent: classes.directionsContent
        }
      });
      break;

    case 'DOWNLOADS':
      drawerContent = React.createElement(DownloadsPopup, {
        product: product,
        installationSheetUrl: customAttributes === null || customAttributes === void 0 ? void 0 : (_customAttributes$fin = customAttributes.find(function (item) {
          return item.attribute_metadata.code == 'hf_installation_instructions';
        })) === null || _customAttributes$fin === void 0 ? void 0 : (_customAttributes$fin2 = _customAttributes$fin.entered_attribute_value) === null || _customAttributes$fin2 === void 0 ? void 0 : _customAttributes$fin2.value,
        isPdp: true
      });
      break;

    case 'CUSTOM':
      drawerContent = React.createElement(React.Fragment, null, !isUserSignedIn ? React.createElement("div", {
        className: "flex flex-col items-center justify-center pb-6 mt-10 mb-2 px-2.5 md_px-0"
      }, React.createElement("h6", {
        className: "text-18 font-bold text-black leading-178 mb-4 md_mb-3"
      }, "Are you a professional?"), React.createElement("p", {
        className: "text-center md_text text-bronze mb-3"
      }, "Interested in gaining access to additional information and resources?"), React.createElement(Button, {
        classes: {
          content: classes.loginCreateBtn
        },
        priority: "low",
        fullWidth: true,
        onClick: function onClick() {
          return history.push({
            pathname: '/sign-in',
            state: {
              pdp: true
            }
          });
        },
        "aria-label": "Login or create a web profile"
      }, "LOGIN OR CREATE A WEB PROFILE")) : null, React.createElement("div", {
        className: "p-4 md_p-9 bg-snowbound mt-3 text-center md_text-left"
      }, React.createElement("h6", {
        className: "text-black mb-2.5 md_mb-3 font-bold"
      }, "NEED A DIFFERENT SIZE?"), React.createElement("div", {
        className: "text-bronze"
      }, "We may be able to help. Contact your", ' ', React.createElement(Link, {
        target: "_blank",
        to: "/where-to-buy/buy-local",
        className: "underline",
        "aria-label": "Go to Buy Local page"
      }, "local Showroom"), ' ', "or", ' ', React.createElement(Link, {
        target: "_blank",
        className: "underline",
        to: "/find-a-rep/residential",
        "aria-label": "Go to Residential Sales Representative page"
      }, "Sales Rep"), ".")), React.createElement("div", {
        style: {
          opacity: isUserSignedIn ? '1' : '0.5'
        },
        onClick: function onClick(e) {
          return !isUserSignedIn && e.preventDefault();
        },
        className: classes.downloadButton
      }, React.createElement(DownloadsPopup, {
        product: product,
        installationSheetUrl: customAttributes === null || customAttributes === void 0 ? void 0 : (_customAttributes$fin3 = customAttributes.find(function (item) {
          return item.attribute_metadata.code == 'hf_custom_pdfs';
        })) === null || _customAttributes$fin3 === void 0 ? void 0 : (_customAttributes$fin4 = _customAttributes$fin3.entered_attribute_value) === null || _customAttributes$fin4 === void 0 ? void 0 : _customAttributes$fin4.value,
        familyCustomPdfs: true,
        isPdp: true
      })), !isUserSignedIn || isConsumer || isHfEmployee ? null : React.createElement("div", {
        className: classes.quoteButton
      }, React.createElement(Link, {
        to: "/custom-product-request-form",
        "aria-label": "Custom Quote Request Form",
        target: "_blank"
      }, "Custom Quote Request Form"), ' '));
      break;

    case 'SELECT_OPTIONS':
      drawerContent = React.createElement(SelectedOptionsContent, {
        option: option
      });
      break;

    case 'BUY_ONLINE':
      drawerContent = React.createElement(BuyOnlineContent, {
        customAttributes: customAttributes
      });
      break;
  }

  var drawerClasses = type ? classes.drawerWrapper_Active : classes.drawerWrapper;
  return React.createElement("div", {
    ref: ref,
    className: drawerClasses
  }, React.createElement("div", {
    className: classes.drawerContent
  }, React.createElement("div", {
    className: "flex flex-col h-full"
  }, React.createElement(DrawerHeader, {
    title: (_drawerTitle$type = drawerTitle[type]) === null || _drawerTitle$type === void 0 ? void 0 : _drawerTitle$type.title,
    close: close
  }), React.createElement("div", {
    className: classes.drawerContentWrapper
  }, drawerContent))));
});
export default Drawer;